import { useTranslation } from 'react-i18next';
import { YStack, Text } from 'tamagui';

import { BaseStationQRCode } from '../../../components/common';

export const QrCodeSetupView: React.FC = () => {
  const { t } = useTranslation();
  return (
    <YStack alignItems="center" gap={'$4'}>
      <BaseStationQRCode />
      <Text fontFamily="$heading" fontSize="$8" fontWeight="$4" color="$color12">
        {t('lock.waitingForDeviceSetup')}
      </Text>
    </YStack>
  );
};
